module.exports = __webpack_public_path__ + "static/media/next_white.bb0f10a2.svg";